module.exports = __webpack_public_path__ + "static/media/Bayleef_gaussian2.f29a96d4.png";